import { api } from '../../lib/api';
import type { CreateTrainingAttemptRecordData } from '../../lib/api';
import type { PlatformScope } from '@examflow/core';

/**
 * Phase-4 thin facade: map completed Attempts onto existing learning APIs.
 * No new server Attempt lifecycle table — training → training-records, mock → ability-snapshots.
 */
export const attemptEvidenceClient = {
  async saveTrainingEvidence(payload: CreateTrainingAttemptRecordData) {
    // Defense: never POST evidenceScope:null (Zod enum rejects null).
    const sanitized: CreateTrainingAttemptRecordData = {
      ...payload,
      questionMetrics: payload.questionMetrics.map((metric) => {
        const { evidenceScope, ...rest } = metric;
        return evidenceScope === 'aggregate' ? metric : rest;
      }),
    };
    return api.learning.saveTrainingRecord(sanitized);
  },

  async saveMockAbilityEvidence(input: {
    platformScope: PlatformScope;
    dimensions: Array<{
      sectionId: string;
      label: string;
      accuracy: number;
      answeredCount: number;
      correctCount: number;
    }>;
    sourceRefId: string;
  }) {
    return api.learning.saveAbilitySnapshot({
      platformScope: input.platformScope,
      source: 'mock',
      dimensions: input.dimensions,
      sourceRefId: input.sourceRefId,
    });
  },

  async saveDiagnosisAbilityEvidence(input: {
    platformScope: PlatformScope;
    dimensions: Array<{
      sectionId: string;
      label: string | null;
      accuracy: number;
      answeredCount: number;
      correctCount: number;
    }>;
    overallScore: number;
    sourceRefId?: string | null;
  }) {
    return api.learning.saveAbilitySnapshot({
      platformScope: input.platformScope,
      source: 'diagnosis',
      dimensions: input.dimensions.map((dimension) => ({
        ...dimension,
        label: dimension.label ?? dimension.sectionId,
      })),
      overallScore: input.overallScore,
      sourceRefId: input.sourceRefId ?? null,
    });
  },
};
